export default __webpack_public_path__ + "static/media/logo.f7703bf6.png";